import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { RatingtypeModel } from 'projects/core/src/lib/models/ratingtype.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-ratingtype-basedata',
  templateUrl: './ratingtype-basedata.component.html',
  styleUrls: ['./ratingtype-basedata.component.scss']
})
export class RatingtypeBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() ratingtype: RatingtypeModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    name_de: new UntypedFormControl('', [Validators.required]),
    name_en: new UntypedFormControl('', [Validators.required]),
    legend_de: new UntypedFormControl(''),
    legend_en: new UntypedFormControl(''),
    min_value: new UntypedFormControl('', [Validators.required, Validators.min(0)]),
    max_value: new UntypedFormControl('', [Validators.required, Validators.min(0)]),
    step: new UntypedFormControl('', [Validators.required, Validators.min(0.5)]),
  }, {
    validators: [this.minMaxValidator]
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.ratingtype !== null) {
      if (this.auth.hasRight('admin.ratingtype.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.ratingtype.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
      if (this.ratingtype.updateable === true) {
        this.form.get('min_value').enable();
        this.form.get('max_value').enable();
        this.form.get('step').enable();
      } else {
        this.form.get('min_value').disable();
        this.form.get('max_value').disable();
        this.form.get('step').disable();
      }
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('ratingtypes', this.ratingtype.id, this.form.value).subscribe({
        next: (result: any) => {
          this.ratingtype.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.ratingtype.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.ratingtype.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.ratingtype.getLang('name', this.transloco.getActiveLang()) }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('ratingtypes', this.ratingtype.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.ratingtype.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/ratingtypes']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.ratingtype !== null) {
      this.form.patchValue({
        name_de: this.ratingtype.getLang('name', 'DE'),
        name_en: this.ratingtype.getLang('name', 'EN'),
        legend_de: this.ratingtype.getLang('legend', 'DE'),
        legend_en: this.ratingtype.getLang('legend', 'EN'),
        min_value: this.ratingtype.min_value,
        max_value: this.ratingtype.max_value,
        step: this.ratingtype.step,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

  private minMaxValidator(group: UntypedFormGroup): any {
    return (group.get('max_value')?.value > group.get('min_value')?.value) ? null : { minMax: true };
  }

}
